import { render, staticRenderFns } from "./DecoderStreamingStatusLabel.vue?vue&type=template&id=6261afab"
import script from "./DecoderStreamingStatusLabel.vue?vue&type=script&lang=js"
export * from "./DecoderStreamingStatusLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports